import { ResourceTypeEnum } from '@/types/schema';

import articleConfig from '../modules/article/config';
import checkInConfig from '../modules/check-in/config';
import courseConfig from '../modules/course/config';
import eventConfig from '../modules/eventContent/config';
import exerciseConfig from '../modules/exercise/config';
import externalContentConfig from '../modules/external-content/config';
import homeworkConfig from '../modules/homework/config';
import knowledgeAssetConfig from '../modules/knowledge-asset/config';
import microLearningConfig from '../modules/micro-learning/config';
import pathConfig from '../modules/path/config';
import quizConfig from '../modules/quiz/config';
import scormConfig from '../modules/scorm/config';
import surveyConfig from '../modules/survey/config';
import taskConfig from '../modules/task/config';

const contentConfig = {
  [ResourceTypeEnum.Task]: taskConfig,
  [ResourceTypeEnum.Path]: pathConfig,
  [ResourceTypeEnum.Quiz]: quizConfig,
  [ResourceTypeEnum.Scorm]: scormConfig,
  [ResourceTypeEnum.Exercise]: exerciseConfig,
  [ResourceTypeEnum.Course]: courseConfig,
  [ResourceTypeEnum.MicroLearning]: microLearningConfig,
  [ResourceTypeEnum.Checkin]: checkInConfig,
  [ResourceTypeEnum.Homework]: homeworkConfig,
  [ResourceTypeEnum.ExternalContent]: externalContentConfig,
  [ResourceTypeEnum.Article]: articleConfig,
  [ResourceTypeEnum.Survey]: surveyConfig,
  [ResourceTypeEnum.ExternalEventContent]: eventConfig(ResourceTypeEnum.ExternalEventContent),
  [ResourceTypeEnum.LiveEventContent]: eventConfig(ResourceTypeEnum.LiveEventContent),
  [ResourceTypeEnum.OfflineEventContent]: eventConfig(ResourceTypeEnum.OfflineEventContent),
  [ResourceTypeEnum.RecurringExternalEventContent]: eventConfig(
    ResourceTypeEnum.RecurringExternalEventContent,
  ),
  [ResourceTypeEnum.RecurringLiveEventContent]: eventConfig(
    ResourceTypeEnum.RecurringLiveEventContent,
  ),
  [ResourceTypeEnum.RecurringOfflineEventContent]: eventConfig(
    ResourceTypeEnum.RecurringOfflineEventContent,
  ),
  [ResourceTypeEnum.KnowledgeAsset]: knowledgeAssetConfig,
};

export const CONTENT_TYPE_LOWER_CASE_i18n_CONFIG = {
  [ResourceTypeEnum.Task]: `Common:ResourceTypeSM.Task`,
  [ResourceTypeEnum.Path]: `Common:ResourceTypeSM.Path`,
  [ResourceTypeEnum.Quiz]: `Common:ResourceTypeSM.Quiz`,
  [ResourceTypeEnum.Scorm]: `Common:ResourceTypeSM.Scorm`,
  [ResourceTypeEnum.Exercise]: `Common:ResourceTypeSM.Exercise`,
  [ResourceTypeEnum.Course]: `Common:ResourceTypeSM.Course`,
  [ResourceTypeEnum.Checkin]: `Common:ResourceTypeSM.Checkin`,
  [ResourceTypeEnum.Homework]: `Common:ResourceTypeSM.Homework`,
  [ResourceTypeEnum.ExternalContent]: `Common:ResourceTypeSM.ExternalContent`,
  [ResourceTypeEnum.Article]: `Common:ResourceTypeSM.Article`,
  [ResourceTypeEnum.Survey]: `Common:ResourceTypeSM.Survey`,
  [ResourceTypeEnum.LiveEventContent]: 'Common:ResourceType.Live',
  [ResourceTypeEnum.ExternalEventContent]: 'Common:ResourceType.External',
  [ResourceTypeEnum.OfflineEventContent]: 'Common:ResourceType.Offline',
  [ResourceTypeEnum.RecurringLiveEventContent]: 'Common:ResourceType.Live',
  [ResourceTypeEnum.RecurringExternalEventContent]: 'Common:ResourceType.External',
  [ResourceTypeEnum.RecurringOfflineEventContent]: 'Common:ResourceType.Offline',
  [ResourceTypeEnum.KnowledgeAsset]: `Common:ResourceTypeSM.KnowledgeAsset`,
  [ResourceTypeEnum.MicroLearning]: `Common:ResourceTypeSM.MicroLearning`,
};

export default contentConfig;
